var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15004_308909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1381 2.99992C14.2631 3.12491 14.3334 3.29446 14.3334 3.47125V14.9999C14.3334 15.1767 14.2632 15.3463 14.1382 15.4713C14.0131 15.5963 13.8436 15.6666 13.6667 15.6666H2.33341C2.1566 15.6666 1.98703 15.5963 1.86201 15.4713C1.73699 15.3463 1.66675 15.1767 1.66675 14.9999V0.999919C1.66675 0.823108 1.73699 0.653538 1.86201 0.528514C1.98703 0.40349 2.1566 0.333252 2.33341 0.333252H11.1954C11.3722 0.33329 11.5418 0.403552 11.6667 0.528585L14.1381 2.99992Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.1805L4.722 5.90183C4.75619 5.93605 4.79741 5.96242 4.84281 5.9791C4.88821 5.99579 4.93669 6.00239 4.9849 5.99846C5.03311 5.99453 5.07988 5.98015 5.12198 5.95633C5.16407 5.9325 5.20048 5.89981 5.22867 5.8605L6.66667 3.84717",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5H11.6667",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.514L4.722 9.23533C4.75619 9.26955 4.79741 9.29591 4.84281 9.3126C4.88821 9.32928 4.93669 9.33589 4.9849 9.33195C5.03311 9.32802 5.07988 9.31365 5.12198 9.28982C5.16407 9.266 5.20048 9.2333 5.22867 9.194L6.66667 7.18066",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.33325H11.6667",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11.8472L4.722 12.5686C4.75619 12.6028 4.79741 12.6292 4.84281 12.6458C4.88821 12.6625 4.93669 12.6691 4.9849 12.6652C5.03311 12.6613 5.07988 12.6469 5.12198 12.6231C5.16407 12.5993 5.20048 12.5666 5.22867 12.5272L6.66667 10.5139",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6665H11.6667",
    stroke: "#6B6C7E",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15004_308909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.0df50304a4a1beb609c34c0ac0d7b8e2.svg";
export { ForwardRef as ReactComponent };